{
  "P2860": "Cites",
  "P921": "Main subject",
  "P3181": "OpenCitations bibliographic resource ID",
  "P364": "Original language of work"
}
